import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { IRAli } from '../../../shared/services/api/fazenda/alimentacao/AlimentacaoService';

async function RAli(dados: IRAli[], dia: string) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  const Quantidade = dados.length;
  const rows = dados.map((row) => {
    return [
      { text: row.nome, alignment: 'left', fontSize: 10 },
      { text: row.fazenda, alignment: 'left', fontSize: 10},
      { text: row.fazenda1, alignment: 'left', fontSize: 10},
      { text: (row.marco ? 'X' : ''), alignment: 'center', bold: true, fontSize: 10 },
      { text: (row.confirmo ? 'X' : ''), alignment: 'center', bold: true, fontSize: 10 },
    ];
  });

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl = '/logo.png';
  const imageData = await getBase64ImageFromUrl(imageUrl);

  const documentDefinition: any = {
    pageSize: 'A4',
    pageMargins: [20, 22, 10, 30],
    //pageOrientation: 'landscape',
    header: {
      columns: [
        { text: 'Sif - Sistema Integrado de Fazendas', alignment: 'right', color: 'gray',  fontSize: 6,  margin: [0, 10, 30, 0], }
      ]
    },   
    footer: function (currentPage: number, pageCount: number) {
      return {
        text: `Página ${currentPage} de ${pageCount}`,
        alignment: 'right',
        fontSize: 6,
        color: 'gray',
        margin: [0, 0, 30, 0],
      };
    },
    content: [
      {
        style: 'tableExample',
        table: {
          margin: [0, 0, 0, 0],
          widths: [48, 500],
          body: [
            [
              {
                image: imageData,
                width: 50,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],
                table: {
                  body: [
                    [
                      { text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16, margin: [0, 5, 0, 0], bold: true, color: process.env.COR_RELATORIOS_TEXTO, alignment: 'center', fillColor: process.env.COR_RELATORIOS, border: [false, false, false, false] },
                    ],
                    [
                      { text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true] },
                    ],
                    [
                      { text: 'Relatório de Alimentação', margin: [5, 10, 0, 0], fontSize: 18, bold: true, alignment: 'center', border: [false, false, false, false] },
                    ],
                  ]
                }
              }
            ],
          ]
        }
      },
      { text: 'Data: ' + dia, bold: true, fontSize: 12 },
      {
        table: {   
          widths: [280, 80, 80, 25, 35],
          body: [
            [
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
            ],
            [
              { text: 'Nome', alignment: 'left', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Fazenda Marcado', alignment: 'left', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Fazenda Confirmado', alignment: 'left', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Marco', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Confirmo', alignment: 'right', fillColor: '#dddddd', fontSize: 8 },
            ],
            ...rows,
            [
              {text: 'Quantidade de Colaboradores: '+new Intl.NumberFormat('pt-br', {minimumFractionDigits: 0}).format(Quantidade), alignment: 'left',  fontSize: 10, bold: true, border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
            ]
          ]

        },
      },

    ]
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  pdfDocGenerator.open();

}
export default RAli;

